<template>
    <v-layout>
        <SiteAppBarVisitor />
        <v-main class="w-100">
            <v-container fluid class="pa-0">
                <slot></slot>
            </v-container>
        </v-main>
    </v-layout>
</template>